<template>
  <vue-aos animation-class="slide-in animated" :threshold="0">
    <section class="recent-work section-padding" id="recentwork">
      <div class="text-center letter-spacing-md">
        <h1 class="underline text-center text-portfolio4">Recent Work</h1>
      </div>
      <div class="container">
        <div class="row">
          <div
            class="col-sm-4 col-12"
            v-for="(work, index) in recentWork"
            :key="index"
          >
            <div
              class="card my-3 recent-work__work cursor-pointer box-shadow border-0"
            >
              <div class="recent-work__work__img-container rounded">
                <img class="img-fluid rounded" height="300" v-lazy="work.src" />
                <div
                  class="position-absolute d-flex align-items-center justify-content-center flex-column w-100 h-100 recent-work__work__content"
                >
                  <h4 class="text-white recent-work__work__content__title">
                    {{ work.title }}
                  </h4>
                  <a
                    :href="work.link"
                    class="btn btn-outline-portfolio1 mt-3 d-block w-40 recent-work__work__content__view"
                  >
                    View
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-easy-lightbox
        :visible="visible"
        :imgs="recentWork"
        :index="index"
        @hide="handleHide"
      ></vue-easy-lightbox>
    </section>
  </vue-aos>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      index: 0,
      recentWork: [
        {
          title: "Restaurant Eat-247",
          src: require("../../assets/images/home/recent-work/restaurant.png"),
          link: "https://restaurant247.netlify.app",
        },
        {
          title: "JAC Network",
          src: require("../../assets/images/home/recent-work/1.png"),
          link: "https://code-jacnetwork.netlify.app",
        },
        {
          title: "Marble",
          src: require("../../assets/images/home/recent-work/2.png"),
          link: "https://code-marbles.netlify.app",
        },
        {
          title: "Auto",
          src: require("../../assets/images/home/recent-work/3.png"),
          link: "https://code-auto.netlify.app",
        },
        {
          title: "Carpet",
          src: require("../../assets/images/home/recent-work/4.png"),
          link: "https://code-carpet.netlify.app",
        },
        {
          title: "AbbeyRoadBike",
          src: require("../../assets/images/home/recent-work/5.png"),
          link: "https://abbeyroadbike.com",
        },
        {
          title: "Anxiety Anonymous",
          src: require("../../assets/images/home/recent-work/6.png"),
          link: "https://code-anxiety.netlify.app",
        },
        {
          title: "Naseem Al Fajar",
          src: require("../../assets/images/home/recent-work/7.png"),
          link: "https://www.naseemalfajar.com",
        },
        {
          title: "ETHEREUMS TOKEN",
          src: require("../../assets/images/home/recent-work/8.png"),
          link: "https://code-crypto.netlify.app",
        },
      ],
    };
  },
  methods: {
    handleHide() {
      this.visible = false;
    },
  },
};
</script>

<style></style>
